// Narrow entry for the app initializers: `pure` would drag the template fixtures into the initial bundle.
import { setLayoutEngineOn } from './lib/layout-engine/flag';

/** Sets the engine switch from the gateway; any error or 5 s silence = off (today's fixtures). */
export async function loadLayoutEngineFlag(): Promise<void> {
  try {
    const res = await fetch('/api/config/layout-engine', { signal: AbortSignal.timeout(5000) });
    const body: { enabled?: unknown } | null = res.ok ? await res.json() : null;
    // RACE-SAFE: one boot-time call, before the lazy editors read the switch.
    setLayoutEngineOn(body?.enabled === true);
  } catch {
    setLayoutEngineOn(false);
  }
}
